import { Record, Static, String } from "runtypes";

export const SurveyEvaluationRequestRuntype = Record({
  isParentResponses: String,
  schoolSlug: String,
});

export interface ISurveyEvaluationRequest
  extends Static<typeof SurveyEvaluationRequestRuntype> {}



// WEBPACK FOOTER //
// ./src/services/ISurveyEvaluationRequest.ts